import { useNavigate } from "react-router-dom";
import logoImg from "@/assets/logo-icon.png";
import { useAuth } from "@/hooks/useAuth";
import { resetTourForUser } from "@/hooks/useOnboardingTour";
import { Compass } from "lucide-react";
import { toast } from "sonner";

const Footer = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  const handleTakeTour = () => {
    if (isLoading) {
      toast.info("Loading your account...");
      return;
    }

    if (!user) {
      navigate("/auth");
      return;
    }

    // Reset tour state so both phases can replay for this user
    resetTourForUser(user.id);
    navigate("/create?tour=full");
  };

  return (
    <footer className="border-t border-border/50 py-10 bg-card/50">
      <div className="w-full px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <img src={logoImg} alt="Resume Flow AI" className="w-14 h-14 object-contain" />
            <span className="font-heading font-bold text-foreground">Resume Flow AI</span>
          </div>

          <nav className="flex items-center gap-6">
            <button
              onClick={() => navigate("/about")}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              About
            </button>
            <button
              onClick={() => navigate("/contact")}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </button>
          </nav>

          <div className="flex items-center gap-4">
            <button
              onClick={handleTakeTour}
              className="flex items-center gap-1 text-[11px] text-muted-foreground/50 hover:text-muted-foreground transition-colors"
            >
              <Compass className="w-3 h-3" />
              Take a website tour
            </button>
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} Resume Flow AI
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
